export default "__VITE_ASSET__CZ09Yjek__"